import React from 'react';
import { Text } from 'Components/frameworks/text/Text';
import { Title } from 'Components/frameworks/title/Title';
import { useResponsive } from 'Components/utils/responsive/ResponsiveContext';
type Props = {
  infos: Array<{
    items?: Array<string>;
    text?: string;
    title: string;
  }>;
};
export const TourInformation = ({ infos }: Props) => {
  const { isAppMounted } = useResponsive();
  return (
    <div className="grid grid-cols-1 gap-20 sm:grid-cols-2">
      {infos.map(({ items, text, title }, index) => (
        <div key={`${title}-${index}`}>
          <Title className="mb-10" theme="title-brand-n2">
            {title}
          </Title>
          {items && (
            <ul className="text-14 leading-normal text-black">
              {items.map((item, i) => (
                <li className="list-disc py-5" key={`${item}-${i}`}>
                  {item}
                </li>
              ))}
            </ul>
          )}
          {/* remark-breaks splits newlines into text/link nodes that differ between
              Node.js SSR and the browser DOM — only render after mount. */}
          {text && isAppMounted && <Text text={text} />}
        </div>
      ))}
    </div>
  );
};
